import { create } from 'zustand';
import { createPractitionerSlice } from './slices/PractitionerStoreSlice';
import { createBackdropSlice } from './slices/BackdropSlice';
import { createThumbnailsSlice } from './slices/ThumbnailsSlice';
import { createFileUploadSlice } from './slices/FileUploadStoreSlice';
import { createDocumentViewerPermissionsSlice } from './slices/DocumentViewerPermissionsSlice'; // <-- add this import
import { commonMiddlewares } from './middlewares';

export const useDocumentViewerStore = create()(
	commonMiddlewares((set, get) => {
		const globalActions = {
			resetDocumentViewerStore: () => {
				const state = get();
				state.resetPractitionerStore();
				state.resetBackdropStore();
				state.resetThumbnailsStore();
				state.resetFileUploadStore();
				state.resetDocumentViewerPermissionsStore(); // <-- add this line
			},
		};

		return {
			...createPractitionerSlice(set, get),
			...createBackdropSlice(set, get),
			...createThumbnailsSlice(set, get),
			...createFileUploadSlice(set, get),
			...createDocumentViewerPermissionsSlice(set, get), // <-- add this line
			...globalActions,
		};
	})
);
